import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, slugify } from "@/lib/api";

export const SeriesLabel = ({ a }) => (
  <p className="mt-5 font-ui text-sm text-[var(--ink-2)]" data-testid="article-series-label">
    <span className="meta !text-[var(--accent)] mr-2">Series</span>
    {a.series_part ? `Part ${a.series_part} of ` : ""}
    <Link to={`/series/${slugify(a.series)}`} className="italic font-body link-quiet underline underline-offset-4 decoration-[var(--rule)]" data-testid="article-series-link">{a.series}</Link>
  </p>
);

export const SeriesBox = ({ a }) => {
  const [parts, setParts] = useState([]);
  useEffect(() => {
    api.get("/articles", { params: { series: a.series } }).then((r) => setParts(r.data));
  }, [a.series]);
  if (parts.length < 2) return null;

  return (
    <section className="max-w-2xl mx-auto mt-14 border-l-2 border-[var(--accent)] pl-6" data-testid="series-box">
      <p className="meta">The series</p>
      <h2 className="mt-2 font-display text-2xl font-semibold italic">{a.series}</h2>
      <ol className="mt-5 grid gap-3">
        {parts.map((p, i) => {
          const current = p.slug === a.slug;
          return (
            <li key={p.id} className="flex gap-4 items-baseline" data-testid={`series-part-${p.slug}`}>
              <span className="meta w-14 shrink-0">Part {p.series_part || i + 1}</span>
              {current ? (
                <span className="font-display text-lg font-semibold" data-testid="series-current-part">{p.headline} <span className="meta ml-1">· Reading now</span></span>
              ) : (
                <Link to={`/article/${p.slug}`} className="font-display text-lg headline-link">{p.headline}</Link>
              )}
            </li>
          );
        })}
      </ol>
      <Link to={`/series/${slugify(a.series)}`} className="mt-5 inline-block meta link-quiet" data-testid="series-view-all-link">View the whole series</Link>
    </section>
  );
};
